module.exports = __webpack_public_path__ + "img/instagram.18f977b7.svg";